module.exports = "<div>\r\n  <p>\r\n    <img src=\"../../assets/images/assurant_main.jpg\">\r\n  </p>\r\n</div>\r\n\r\n"